import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { toResponseError, type DemoSetupInput, type DemoSetupSuccess } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { useRoleCache } from '../role'

export function useDemoSetup(): UpdateHookResponse<DemoSetupInput, DemoSetupSuccess> {
  const mutation = useTantalimMutation<DemoSetupInput, DemoSetupSuccess>({
    url: '/demo/setup',
  })
  const cache = useRoleCache()

  async function setup(input: DemoSetupInput): Promise<DemoSetupSuccess> {
    try {
      const response = await mutation.mutateAsync(input)
      cache.clearList({ companyId: input.companyId })
      return response
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, setup)
}
